var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_11128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2591,
    cy: 14.8682,
    rx: 14.2669,
    ry: 14.1318,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2444 14.8682C30.2444 22.5149 23.9855 28.7183 16.2591 28.7183C8.53274 28.7183 2.27385 22.5149 2.27385 14.8682C2.27385 7.22145 8.53274 1.01799 16.2591 1.01799C23.9855 1.01799 30.2444 7.22145 30.2444 14.8682Z",
    stroke: "#EAECF0",
    strokeWidth: 0.563333
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0415 7.39453C11.9967 7.39453 8.71777 10.6424 8.71777 14.6489C8.71777 18.6553 11.9967 21.9032 16.0415 21.9032C20.0862 21.9032 23.3652 18.6553 23.3652 14.6489C23.3652 10.6424 20.0862 7.39453 16.0415 7.39453ZM16.0415 11.3514C15.6738 11.3514 15.3757 11.6467 15.3757 12.0109C15.3757 12.3752 15.6738 12.6704 16.0415 12.6704H16.0481C16.4158 12.6704 16.7139 12.3752 16.7139 12.0109C16.7139 11.6467 16.4158 11.3514 16.0481 11.3514H16.0415ZM16.7073 14.6489C16.7073 14.2846 16.4092 13.9894 16.0415 13.9894C15.6738 13.9894 15.3757 14.2846 15.3757 14.6489V17.2868C15.3757 17.651 15.6738 17.9463 16.0415 17.9463C16.4092 17.9463 16.7073 17.651 16.7073 17.2868V14.6489Z",
    fill: "url(#paint0_linear_5_11128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_11128",
    x: 0.865521,
    y: 0.172995,
    width: 30.7875,
    height: 30.517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.563333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.563333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_11128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_11128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_11128",
    x1: 16.0415,
    y1: 7.39453,
    x2: 16.0415,
    y2: 21.9032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7986FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4356FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/infoicon.90bd981013f46cba6021918ef9c4ea7f.svg";
export { ForwardRef as ReactComponent };